

export default function ImagePreviewModal({onClose, image}) {
    return (
        <div className="flex w-full max-w-[1280px] aspect-video p-3 justify-center">
            <img src={image.url || image.thumbnail_url} alt={image.name} decoding="async" width={1280} height={720} className="object-contain relative w-auto h-full" />
        </div>
    )
}